import { Box, IconButton, styled } from '@mui/material';
import theme from 'App.theme';

export const CenteredItems = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const AddSetBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  gap: theme.layout.spacing.small,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const StyledIconButton = styled(IconButton)`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  color: white;
  cursor: pointer;
  z-index: 100;
  background-color: ${theme.colors.active};
  border-radius: 50%;
  padding: 5px;
  &:hover {
    background-color: ${theme.colors.activeLight};
    color: ${theme.colors.active};
  }
`;

export const IconsBox = styled(Box)`
  width: 90px;
  & svg {
    margin: 4px;
    height: 32px;
    width: auto;

    & path {
      fill: ${theme.greys.GREY2};
    }

    &.state-icon-approved path {
      fill: ${theme.colors.green};
    }

    &.state-icon-rejected path {
      fill: ${theme.colors.red};
    }
  }
`;

export const TrayListItemBox = styled(Box)`
  padding: ${theme.layout.spacing.small} 0;
  cursor: pointer;

  &:hover .add-image-icon {
    background-color: ${theme.colors.activeLight};
    border-color: ${theme.colors.active};
  }
`;

export const TrayImageBox = styled(Box, {
  shouldForwardProp: propName => propName != 'width' && propName != 'height',
})<{
  width?: string;
  height?: string;
}>(({ theme, width, height }) => {
  const _height = height || '130px';
  const _width = _height != 'auto' || !width ? 'auto' : width;
  const staticSize = _height == 'auto' ? _width : _height;
  return {
    background: 'none',
    cursor: 'pointer',
    width: 'fit-content',
    maxWidth: '100%',
    border: `1px solid ${theme.greys.GREY1}`,
    borderRadius: '4px',
    overflow: 'hidden',
    '& .tray-image': {
      width: _width,
      height: _height,
      marginBottom: '-4px',
    },
    '&.large-image': {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      height: 'fit-content',
      zIndex: theme.layers.top,
      '& .tray-image': {
        width: 'auto',
        height: 'auto',
        maxWidth: '100vw',
        maxHeight: '100vh',
      },
    },
    '& .tray-image-placeholder': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: staticSize,
      height: staticSize,
      '& .placeholder-label': {
        width: '50%',
        height: '50%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  };
});
